// Angular
import { AfterViewInit, Component, OnInit } from '@angular/core';
// Layout
import { LayoutConfigService, ToggleOptions } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { ApiService } from 'src/app/Services/api.service';

@Component({
	selector: 'kt-brand',
	templateUrl: './brand.component.html',
})
export class BrandComponent implements OnInit, AfterViewInit {
	// Public properties
	headerLogo: string;
	headerStickyLogo: string;
	userPreferences = JSON.parse(localStorage.getItem('userPreferences'));
	toggleOptions: ToggleOptions = {
		target: 'body',
		targetState: 'kt-aside--minimize',
		togglerState: 'kt-aside__brand-aside-toggler--active'
	};

	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 * @param htmlClassService: HtmlClassService
	 */
	constructor(private layoutConfigService: LayoutConfigService, public htmlClassService: HtmlClassService,private service:ApiService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		if(this.userPreferences && this.userPreferences.entityDisplayLogo){
			this.headerLogo = this.userPreferences.entityDisplayLogo
			this.headerStickyLogo = this.userPreferences.entityDisplayLogo
		}else{
			this.headerLogo = localStorage.getItem('logo')|| './../../../../assets/images/logo_1.png';
			this.headerStickyLogo = localStorage.getItem('logo')|| './../../../../assets/images/logo_1.png';
		}
		
	}

	/**
	 * On after view init
	 */
	ngAfterViewInit(): void {
	}
}
